export default {
  policiesContent: {
    header: "Dataships SMS Onboarding",
    attentiveInstructions: {
      integrationConfigTitle: "Attentive Integration Configuration",
      step1:
        "1. To provide your Sign-up Source ID, please configure your Attentive integration in the Dataships Control Panel <1>Click here</1>",
      title: "Attentive Setup Instructions",
      smsSetting: "SMS settings in Attentive ",
      step2:
        "2. To access your Company Display Name in Attentive <1>Click here</1>",
      step3:
        "3. To access your Company General SMS settings in Attentive <1>Click here</1>",
      step4:
        "4. To update your compliance settings in Attentive <1>Click here</1>",
    },
    klaviyoInstructions: {
      title: "Klaviyo Setup Instructions",
      senderTitle: "SMS sender information in Klaviyo",
      step1:
        "1. To access your sender information in Klaviyo <1>Click here</1>",
      complianceChecksTitle: "SMS compliance checks",
      step2:
        "2. To access your sender preferences in Klaviyo <1>Click here</1> ",
      step3:
        "3. To access your SMS Keyword responses settings in Klaviyo <1>Click here</1> ",
      step4:
        "4. Copy the below wording and paste into the <1>Mobile Terms of Service</1> editor in Klaviyo",
      step5a:
        "5a. Copy the Privacy Policy URL below and paste into the SMS opt-in disclaimer setup",
      step5b:
        "5b. Copy the Terms of Service URL below and paste into the SMS opt-in disclaimer setup",
      step5c:
        "5c. Copy the below wording and paste into the SMS opt-in disclaimer editor in Klaviyo",
      step6:
        "6. If the Dataships Customer Success member asks you to access your API key settings in Klaviyo <1>Click here</1> ",
      newSmsListTitle: "New SMS lists setup",
      step7: "7. To access your lists in Klaviyo <1>Click here</1> ",
    },
    shopifyInstructions: {
      title: "Shopify Setup Instructions",
      policySettings: "Policy Settings",
      step1:
        "1. To access your Policies settings in Shopify <1>Click here</1> ",
      privacyPolicy: "Privacy Policy",
      step2:
        "2. Copy the below wording in relation to data processing for SMS marketing purposes and paste into the Privacy Policy editor in Shopify",
      step3:
        "3. Copy the below wording in relation to SMS marketing preferences and paste into the Privacy Policy editor in Shopify",
      termsOfService: "Terms of Service",
      step4:
        "4. Copy the below wording and paste into the Terms of Service editor in Shopify",
      optionalDatashipsSnippet: "<0>Optional:</0> Dataships Snippet",
      step5:
        "5. Copy the code below and paste into the Additional Scripts editor in Shopify.",
      consentCollectionChanges: "SMS consent collection changes in Shopify",
      step6: "To access your Checkout settings in Shopify <1>Click here</1>",
      transactionalMessageChanges: "Transactional SMS Shopify message",
      step7:
        "To access where this language is set in your Shopify Theme <1>Click here</1>",
    },
    loginCTA: "Log in to Dataships",
    error:
      "Oops! Something went wrong. Please try again and consult your Dataships Customer Success member.",
  },
};
